import AdvertisingPage from './AdvertisingPage';

export default AdvertisingPage;
